import React from 'react';
import { Box, BoxProps, useTheme } from '@mui/material';

export interface CustomCardProps extends BoxProps {
  glowOnHover?: boolean;
  glass?: boolean;
}

export const Card: React.FC<CustomCardProps> = ({
  children,
  glowOnHover = false,
  glass = false,
  sx,
  ...props
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      {...props}
      sx={{
        backgroundColor: isDark
          ? (glass ? 'rgba(22, 29, 47, 0.75)' : '#161d2f')
          : (glass ? 'rgba(255, 255, 255, 0.9)' : '#ffffff'),
        backdropFilter: glass ? 'blur(16px)' : 'none',
        border: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e2e8f0',
        borderRadius: 3,
        padding: 3,
        boxShadow: isDark ? 'none' : '0 8px 30px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        ...(glowOnHover && {
          '&:hover': {
            borderColor: theme.palette.primary.main,
            boxShadow: isDark
              ? '0 0 25px rgba(0, 102, 255, 0.3)'
              : '0 10px 30px rgba(0, 80, 203, 0.12)',
            transform: 'translateY(-4px)',
          },
        }),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default Card;
